<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="添加代理"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form @submit="onSubmit"  ref='forms'  style="margin-top: 1.5rem;background-color: white">
            <van-divider  content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa',margin: '0.4rem 0 0 -1.1rem' }" >基础配置</van-divider>
            <van-field
                    v-model="form.name"
                    label="代理账户名"
                    required
                    name="代理账户名"
                    clearable
                    placeholder="请输入代理账户名"
                    :rules="[{ required: true, message: '代理账户名不能为空' }]"
            />
            <!-- <van-field
                    v-model="form.agent_num"
                    clearable
                    required
                    label="代理编号"
                    name="代理编号"
                    placeholder="请输入代理编号"
                    :rules="[{ required: true, message: '代理编号不能为空' }]"
            /> -->
            <van-field
                    v-model="form.password"
                    type="password"
                    clearable
                    required
                    label="代理密码"
                    name="代理密码"
                    placeholder="请输入代理密码"
                    :rules="[{ required: true, message: '代理密码不能为空' }]"
            />
            <van-field
                    v-model="form.tel"
                    type="tel"
                    clearable
                    required
                    label="代理手机"
                    name="代理手机"
                    placeholder="请输入代理手机"
                    :rules="[{ required: true, message: '代理手机不能为空' }]"
            />
            <van-field
                    v-model="form.t1_cost"
                    type="number"
                    clearable
                    required
                    label="T1成本费率"
                    name="T1成本费率"
                    placeholder="请输入T1成本费率"
                    :rules="[{ required: true, message: 'T1成本费率不能为空' }]"
            />
            <van-field
                    v-model="form.t1_term"
                    type="number"
                    clearable
                    required
                    label="T1终端费率"
                    name="T1终端费率"
                    placeholder="请输入T1终端费率"
                    :rules="[{ required: true, message: 'T1终端费率不能为空' }]"
            />
            <van-field
                    v-model="form.t0_cost"
                    type="number"
                    clearable
                    required
                    label="T0成本费率"
                    name="T0成本费率"
                    placeholder="请输入T0成本费率"
                    :rules="[{ required: true, message: 'T0成本费率不能为空' }]"
            />
            <van-field
                    v-model="form.t0_term"
                    type="number"
                    clearable
                    required
                    label="T0终端费率"
                    name="T0终端费率"
                    placeholder="请输入T0终端费率"
                    :rules="[{ required: true, message: 'T0终端费率不能为空' }]"
            />
            <van-field
                    v-model="form.d1_cost"
                    type="number"
                    clearable
                    label="D1成本费率"
                    name="D1成本费率"
                    placeholder="请输入D1成本费率"
            />
            <van-field
                    v-model="form.d1_term"
                    type="number"
                    clearable
                    label="D1终端费率"
                    name="D1终端费率"
                    placeholder="请输入D1终端费率"
            />
            <van-field
                    v-model="form.d0_cost"
                    type="number"
                    clearable
                    label="D0成本费率"
                    name="D0成本费率"
                    placeholder="请输入D0成本费率"
            />
            <van-field
                    v-model="form.d0_term"
                    type="number"
                    clearable
                    label="D0终端费率"
                    name="D0终端费率"
                    placeholder="请输入D0终端费率"
            />
            <van-field
                    v-model="form.unionscan2_cost"
                    type="number"
                    clearable
                    label="银联扫码小于1000成本费率"
                    name="银联扫码小于1000成本费率"
                    placeholder="请输入银联扫码小于1000成本费率"
            />
            <van-field
                    v-model="form.unionscan2_term"
                    type="number"
                    clearable
                    label="银联扫码小于1000终端费率"
                    name="银联扫码小于1000终端费率"
                    placeholder="请输入银联扫码小于1000终端费率"
            />
            <van-field
                    v-model="form.unionscan_cost"
                    type="number"
                    clearable
                    label="银联扫码大于1000成本费率"
                    name="银联扫码大于1000成本费率"
                    placeholder="请输入银联扫码大于1000成本费率"
            />
            <van-field
                    v-model="form.tax_term"
                    type="number"
                    clearable
                    label="税率"
                    name="税率"
                    placeholder="请输入税率0~100之间"
            />

            <van-field
                    v-model="form.code_count"
                    type="digit"
                    clearable
                    required
                    label="收款码数量"
                    name="收款码数量"
                    placeholder="请输入收款码数量"
                    :rules="[{ required: true, message: '收款码数量不能为空' }]"
            />


            <van-field
                    v-model="form.bse_lice_nm"
                    clearable
                    label="营业执照名"
                    name="营业执照名"
                    placeholder="请输入营业执照名"
            />
            <van-field
                    v-model="form.bus_lic_no"
                    clearable
                    label="营业执照号"
                    name="营业执照号"
                    placeholder="请输入营业执照号"
            />
            <van-field name="自助发码" label="自助发码">
                <template #input>
                    <van-radio-group v-model="form.mastatus" direction="horizontal">
                        <van-radio :name="1">允许</van-radio>
                        <van-radio :name="0">不允许</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field name="发展下级" label="发展下级">
                <template #input>
                    <van-radio-group v-model="form.allow" direction="horizontal">
                        <van-radio :name="1">允许</van-radio>
                        <van-radio :name="0">不允许</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field name="代理状态" label="代理状态">
                <template #input>
                    <van-radio-group v-model="form.status" direction="horizontal">
                        <van-radio :name="1">启用</van-radio>
                        <van-radio :name="0">禁用</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field name="是否扣税" label="是否扣税">
                <template #input>
                    <van-radio-group v-model="form.is_tax" direction="horizontal">
                        <van-radio :name="1">是</van-radio>
                        <van-radio :name="0">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    v-model="form.info"
                    rows="1"
                    clearable
                    autosize
                    label="代理备注"
                    type="textarea"
                    placeholder="请输入备注"
            />

            <!--负责人身份证正面照片: start-->
            <van-field  name="uploader" label="负责人身份证正面"  >
                <template #input>
                    <van-uploader :after-read="afterRead" v-model="fileList"   multiple :max-count="1"  />
                </template>
            </van-field>

            <!--负责人身份证反面照片: start-->
            <van-field  name="uploader" label="负责人身份证反面"  >
                <template #input>
                    <van-uploader :after-read="afterReada" v-model="fileLista"  multiple :max-count="1"  />
                </template>
            </van-field>

            <!--负责人手持证件照照片: start-->
            <van-field  name="uploader" label="负责人手持证件照"   >
                <template #input>
                    <van-uploader :after-read="afterReadb" v-model="fileListb"  multiple :max-count="1"  />
                </template>
            </van-field>

            <!--结算银行卡照片: start-->
            <van-field  name="uploader" label="结算银行卡照片"   >
                <template #input>
                    <van-uploader :after-read="afterReadc" v-model="fileListc"  multiple :max-count="1"  />
                </template>
            </van-field>

            <!--结算银行卡反面照片: start-->
            <van-field  name="uploader" label="结算银行卡反面照片"   >
                <template #input>
                    <van-uploader :after-read="afterReadd" v-model="fileListd"  multiple :max-count="1"  />
                </template>
            </van-field>

            <!--办公内景照片: start-->
            <van-field  name="uploader" label="办公内景照片"  >
                <template #input>
                    <van-uploader :after-read="afterReade" v-model="fileListe"  multiple :max-count="1"  />
                </template>
            </van-field>

            <!--营业执照电子版: start-->
            <van-field  name="uploader" label="营业执照电子版"  >
                <template #input>
                    <van-uploader :after-read="afterReadf" v-model="fileListf"  multiple :max-count="1"  />
                </template>
            </van-field>


          <!--结算信息-->
            <van-divider  content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa',margin: '0.4rem 0 0 -1.1rem' }" >结算信息</van-divider>
            <van-field
                    v-model="form.banks.s_sfz"
                    clearable
                    label="身份证号"
                    name="身份证号"
                    placeholder="请输入身份证号"
            />
            <van-field
                    v-model="form.banks.s_dz"
                    clearable
                    label="联系地址"
                    name="联系地址"
                    placeholder="请输入联系地址"
            />
            <van-field
                    v-model="form.banks.s_khh"
                    clearable
                    label="开户行"
                    name="开户行"
                    placeholder="请输入开户行"
            />
            <van-field
                    v-model="form.banks.s_zh"
                    clearable
                    label="支行名称"
                    name="支行名称"
                    placeholder="请输入支行名称"
            />
            <van-field
                    v-model="form.banks.s_hm"
                    clearable
                    label="银行户名"
                    name="银行户名"
                    placeholder="请输入银行户名"
            />
            <van-field
                    v-model="form.banks.s_kh"
                    clearable
                    label="银行卡号"
                    name="银行卡号"
                    placeholder="请输入银行卡号"
            />
        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit"  round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    export default {
        name: "AgentLogin", //代理添加
        data() {
            return {
                fileList: [],
                fileLista: [],
                fileListb:[],
                fileListc:[],
                fileListd:[],
                fileListe:[],
                fileListf:[],

                form:{
                    name: '',
                    agent_num: '',
                    password:'',
                    tel:'',
                    t1_cost:'',
                    t1_term:'',
                    t0_cost:'',
                    t0_term:'',
                    d1_cost:'',
                    d1_term:'',
                    d0_cost:'',
                    d0_term:'',
                    unionscan2_cost:'',
                    unionscan2_term:'',
                    unionscan_cost:'',
                    tax_term:'',
                    code_count:'',
                    bse_lice_nm:'',
                    bus_lic_no:'',
                    mastatus:1,
                    allow:1,
                    status:1,
                    is_tax:0,

                    info:'',
                    agent_img_principal_id_card_front: '',
                    agent_img_principal_id_card_obverse:'',
                    agent_img_holding_photo:'',
                    agent_img_bank_card:'',
                    agent_img_bank_card_back:'',
                    agent_img_work_interior:'',
                    agent_img_electronic_business_license:'',

                    //    结算信息
                    banks:{}
                },
            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {

            afterRead(file) {
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_principal_id_card_front=response.data.local_img
                        console.log(response.data.local_img)
                    }
                })
            },
            afterReada(file) {
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_principal_id_card_obverse=response.data.local_img
                    }
                })
            },
            afterReadb(file){
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_holding_photo=response.data.local_img
                    }
                })
            },
            afterReadc(file){
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_bank_card=response.data.local_img
                    }
                })
            },
           afterReadd(file){
            this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                localData:file.content,
                openid: window.localStorage.getItem("openid")

            }).then(response => {
                if (response && response.data.code== 200) {
                    this.form.agent_img_bank_card_back=response.data.local_img
                }
            })
          },
           afterReade(file){
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_work_interior=response.data.local_img
                    }
                })
            },
            afterReadf(file){
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.form.agent_img_electronic_business_license=response.data.local_img
                    }
                })
            },


            // 左侧返回
            onClickLeft() {
                this.$router.push("/AgentManagement");
                // window.history.go(-1)
            },
            // 提交
            onSubmit(v) {
                this.$refs.forms.validate().then(() => {
                    var toast = Toast.loading({
                        duration: 0,
                        message: '添加中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
                    // console.log('submit', values);
                    this.$http.post('/wechat/api.agent.agent/addAgent', this.form).then(response => {
                        toast.clear();
                        console.log(response.data);
                        if (response && response.data.code== 200) {
                            Notify({type: 'success', message: response.data.msg});
                            this.$router.push("/AgentManagement");

                            // VueCookie.set('salesmanInfo', response.data.data, 360000);
                            // window.location.href = that.redirect;

                        }else{
                            Notify({type: 'danger', message: response.data.msg});
                        }
                    })
                }).catch(() => {
                    this.$toast.fail('必填项未填写')
                })


                console.log(v)
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;



            },
        },
        // watch:{
        //     'salesman_img_principal_id_card_front':{
        //         handler:function (v) {
        //             console.log(v)
        //         }
        //     }
        // }
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }

    .van-field >>>.van-field__label{
        width: 40px;
    }
</style>
